module.exports = __webpack_public_path__ + "img/61.e13a0bf4.jpg";